import { render, staticRenderFns } from "./ManageForm2.vue?vue&type=template&id=15a4fe46&"
import script from "./ManageForm2.vue?vue&type=script&lang=js&"
export * from "./ManageForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports